import clsx from 'clsx';
import { PropsWithChildren } from 'react';

import styles from './editor-sidebar-holder.module.scss';

export const EditorSidebarHolder = (props: EditorSidebarHolderProps) => {
  const { className, children, processing, ...rest } = props;

  return (
    <div
      className={clsx(styles.editorSidebarHolder, className, {
        [styles.processing]: processing,
      })}
      {...rest}
    >
      <div>{children}</div>
    </div>
  );
};

interface EditorSidebarHolderProps extends PropsWithChildren {
  className?: string;
  processing?: boolean; // TODO pass this in - DM-360
}
